import styled from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { createPortal } from 'react-dom';
import { select } from '~/lib/select';
import { HelpButton } from '~/ui/buttons';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { HelpPages, useHelpStore } from './Store';

const Button = styled(HelpButton)`
  position: fixed;
  top: 70px;
  right: 20px;
  font-size: 30px;
  z-index: hud;
  &:focus {
    outline: 2px solid blue;
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 25px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
  @media ((max-width: 580px) and (max-height: 300px)) {
    top: 50px;
    right: 10px;
  }
`;

const selector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenHelpMenuButton = () => {
  const { toggle, setPage } = useHelpStore();
  const { pause } = useMediaPlayerStore(selector);

  return createPortal(
    <Button
      aria-label={t`Help`}
      onClick={() => {
        setPage(HelpPages.Root);
        pause();
        toggle();
      }}
    />,
    document.getElementById('root')!
  );
};
